export type CloudSessionExpiredToastModel =
  | {
      readonly kind: "hidden";
    }
  | {
      readonly kind: "visible";
      readonly description: "reconnecting" | "expired" | "error";
      readonly action: "reconnect" | null;
      readonly errorMessage: string | null;
    };

export function resolveCloudSessionExpiredToastModel(input: {
  readonly shouldShow: boolean;
  readonly reconnecting: boolean;
  readonly reconnectError: string | null;
}): CloudSessionExpiredToastModel {
  if (!input.shouldShow) {
    return { kind: "hidden" };
  }
  if (input.reconnecting) {
    return {
      kind: "visible",
      description: "reconnecting",
      action: null,
      errorMessage: null,
    };
  }
  if (input.reconnectError) {
    return {
      kind: "visible",
      description: "error",
      action: "reconnect",
      errorMessage: input.reconnectError,
    };
  }
  return {
    kind: "visible",
    description: "expired",
    action: "reconnect",
    errorMessage: null,
  };
}
